var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphicDesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0V78.9677H39.2097V86.7097C39.2097 91.8333 43.3764 96 48.5 96C53.6236 96 57.7903 91.8333 57.7903 86.7097V78.9677H96.5V0H0.5ZM54.6935 86.7097C54.6935 90.1254 51.9157 92.9032 48.5 92.9032C45.0843 92.9032 42.3064 90.1254 42.3064 86.7097V82.0645H54.6935V86.7097ZM54.6935 78.9677H42.3064V55.7419H54.6935V78.9677ZM55.0744 52.6452H41.9255L39.3815 43.7404L46.9516 35.088V40.543C45.1539 41.184 43.8548 42.8872 43.8548 44.9032C43.8548 47.4643 45.939 49.5484 48.5 49.5484C51.061 49.5484 53.1452 47.4643 53.1452 44.9032C53.1452 42.8872 51.8461 41.184 50.0484 40.543V35.088L57.6185 43.7404L55.0744 52.6452ZM48.5 43.3548C49.3547 43.3548 50.0484 44.0485 50.0484 44.9032C50.0484 45.7579 49.3547 46.4516 48.5 46.4516C47.6453 46.4516 46.9516 45.7579 46.9516 44.9032C46.9516 44.0485 47.6453 43.3548 48.5 43.3548ZM50.6523 31.0777C64.501 32.1445 75.5209 43.3626 76.292 57.2919H73.2742V66.5822H82.5645V57.2919H79.3888C78.8112 45.6867 71.8373 35.7662 61.909 30.9693H73.2742V34.0661H82.5645V24.7757H73.2742V27.8725H23.7258V24.7757H14.4355V34.0661H23.7258V30.9693H35.091C25.1627 35.7662 18.1888 45.6867 17.6112 57.2919H14.4355V66.5822H23.7258V57.2919H20.708C21.4791 43.3626 32.4974 32.1445 46.3477 31.0777L35.941 42.9693L39.2097 54.4088V69.6774H9.79032V21.6774H87.2097V69.6774H57.7903V54.4088L61.059 42.9693L50.6523 31.0777ZM76.371 63.4839V60.3871H79.4677V63.4839H76.371ZM76.371 30.9677V27.871H79.4677V30.9677H76.371ZM20.629 27.871V30.9677H17.5323V27.871H20.629ZM20.629 60.3871V63.4839H17.5323V60.3871H20.629ZM93.4032 75.871H57.7903V72.7742H90.3064V18.5806H6.69355V72.7742H39.2097V75.871H3.59677V15.4839H93.4032V75.871ZM93.4032 12.3871H3.59677V3.09677H93.4032V12.3871Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79033 6.19354H6.69356V9.29032H9.79033V6.19354Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9839 6.19354H12.8871V9.29032H15.9839V6.19354Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1774 6.19354H19.0807V9.29032H22.1774V6.19354Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9839 82.0645H60.8871V85.1613H63.9839V82.0645Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1774 82.0645H67.0807V85.1613H70.1774V82.0645Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.371 82.0645H73.2742V85.1613H76.371V82.0645Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7258 82.0645H20.629V85.1613H23.7258V82.0645Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9194 82.0645H26.8226V85.1613H29.9194V82.0645Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1129 82.0645H33.0161V85.1613H36.1129V82.0645Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicDesign);
export default __webpack_public_path__ + "static/media/graphic-design.0af6c5f63718477af5538f323ccabb29.svg";
export { ForwardRef as ReactComponent };